import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { class: "container centered" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { style: {"margin":"60px auto"} }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "lh32 fs24 fw600" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "管理画面で日程調整一覧を確認するためには、仲介会社様より招待を受けてください。", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "w50 centered mc",
  style: {"max-width":"320px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fl" }, "御社の招待コード:", -1)
const _hoisted_16 = { class: "fs12 w100 fw600" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  class: "fs12 grey",
  rel: "nofollow",
  "data-method": "delete",
  href: "/users/sign_out"
}, [
  /*#__PURE__*/_createTextVNode(" ログアウト "),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/logo/logo140.png`),
            height: "60"
          }, null, 8, _hoisted_5)
        ]),
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("h5", _hoisted_8, [
          _createTextVNode(" 現在"),
          (_ctx.rm.userInfo)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.rm.userInfo.company_name) + "様を", 1))
            : _createCommentVNode("", true),
          _createTextVNode("招待している仲介会社が"),
          _hoisted_10,
          _createTextVNode("いないためご利用いただけません。 ")
        ]),
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        (_ctx.rm.invite_connect_key)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("label", _hoisted_16, [
                _createVNode(_component_CopyButton, {
                  linkUrl: _ctx.rm.invite_connect_key,
                  gtagCategory: `invite_connect_keyをコピー`,
                  buttonName: `コピー`,
                  class: "fr"
                }, null, 8, ["linkUrl"])
              ]),
              _createVNode(_component_TextfieldTag, {
                style: {"height":"50px","min-width":"280px","max-width":"100%","margin-top":"10px"},
                class: _normalizeClass(`fl fs14 roundForm w100 copyInviteConnectKey`),
                value: _ctx.rm.invite_connect_key,
                onClickTextfield: _ctx.clickTextfield
              }, null, 8, ["value", "onClickTextfield"])
            ]))
          : _createCommentVNode("", true),
        _hoisted_17,
        _hoisted_18
      ]),
      _createElementVNode("div", {
        class: "posAb pointer",
        style: {"right":"5px","bottom":"5px"},
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickLoggedOutButton && _ctx.clickLoggedOutButton(...args)))
      }, _hoisted_20)
    ])
  ]))
}